import BackToCatalog from './BackToCatalog';

export default BackToCatalog;
